import { API_ROOT } from "../../supplementary_components/requests"
import { DRIVER_ADD_CONF } from "./driverAddConf"
import { DRIVER_PAGE_OBJECT } from "./driverPageConf"

import { NestedValueExtractor } from "../../general_components/content_management/list_view/listView";

export const DriverStatusFormatter = (value)=>{
    switch (value) {
        case 'pending':
            return "Pending"
        case 'active':
            return "Active"
        case 'inactive':
            return "Inactive"
        case 'atHome':
            return "At Home"
        case 'Pending':
            return "pending"
        case 'Active':
            return "active"
        case 'Inactive':
            return "inactive"
        case 'At Home':
            return "atHome"
        default:
            return ''
    }
}
export function DriverStatusColorGenerator(status){
    switch (status) {
        case "pending":
            return "var(--inProgressYellow)";
        case "active":
            return "var(--main-color)";
        case "inactive":
            return "var(--alert-color)";
        case "atHome":
            return "var(--inProgressPurple)";
        default:
            break;
    }
}
// {
//     "id": 170,
//     "firstName": "ZAKARIA",
//     "middleName": "MAHAMED",
//     "lastName": "ABDI",
//     "currentTruckNumber": "262409",
//     "phoneNumber": "(507) 304-3648",
//     "licenseNumber": "Z000083293200",
//     "driverStatus": "active",
//     "driverType": "Company"
// }
export const DRIVER_LISTING_CONF = {
    getRequestLink: API_ROOT+"drivers",
    // columnProportions: "6.5% 13.3% 10.66% 8.37% 18.5% 11.86% 13.37% 1fr",
    columnProportions: "1.2fr 0.8fr 1.2fr 0.8fr 1fr 1fr 0.8fr 0.5fr",
    dataTitle: "Driver",
    dataTitlePlural:"Drivers",
    addButton:true,
    addConf: DRIVER_ADD_CONF,
    minAccessToItemPage: { key: 'DRIVERS', level: 'VIEW' },
    filtration:{
        // multipleFiltrationAllowed: true,
        filtrationLinkRoot: "drivers/filtration",
        searchByFieldNames:[
            {
                valueLocation: 'driverStatus',
                filtrationLbl: "status:",
                searchKey: "byStatus",
                hint: "Status",
                searchTermTransformer: (term)=>{return term.replaceAll(" ", "")},
                customSuggestions:[
                    "Active",
                    "Inactive",
                    "Pending",
                    "At Home"
                ]
            },
            {
                valueLocation: 'driverType',
                filtrationLbl: "type:",
                searchKey: "byType",
                hint: "Type",
                customSuggestions:[
                    "Company",
                    "Lease",
                    "Owner"
                ]
            },
            // {
            //     // valueLocation: ['driver1', 'driver2'],
            //     filtrationLbl: "driver(s):",
            //     searchKey: "byDriver",
            //     hint: "Solo, Team, ...",
            //     conditionalCheck: (term, data)=>{
            //         if(term === "no drivers"){
            //             return !data.driver1 && !data.driver2;
            //         }else if(term === "solo"){
            //             return (data.driver1 !== null && data.driver2 === null) || (data.driver1 === null && data.driver2 !== null);
            //         }else if(term === "team"){
            //             return data.driver1 !== null && data.driver2 !== null;
            //         }
            //         return false;
            //     },
            //     customSuggestions:[
            //         "No Drivers",
            //         "Solo",
            //         "Team"
            //     ]
            // },
            // {
            //     filtrationLbl: "dispatcher:",
            //     searchKey: "byDispatcher",
            //     hint: "Dispatcher",
            //     conditionalCheck: (term, data)=>{
            //         if(term === "no dispatch"){
            //             return !data.dispatcher && !data.dispatchTeam;
            //         }else if(data.dispatcher){
            //             return (data.dispatcher['firstName'] + " " + data.dispatcher['lastName']).toLocaleLowerCase().includes(term);
            //         }else if(data.dispatchTeam){
            //             return (data.dispatchTeam['teamName']).toLocaleLowerCase().includes(term);
            //         }
            //         return false;
            //     },
            //     customSuggestions:[
            //         "No Dispatch"
            //     ],
            //     acceptSuggestionAsTerm: true,
            // },
        ]
    },
    pageConf: new DRIVER_PAGE_OBJECT(),
    category: 'drivers',
    columns :[
        {
            label: "First Name",
            columnName: "firstName",
            sortable: true,
            identifierColumnName: "id",
            clickable: true,
            path: "/drivers/",
        },
        {
            label: "Middle  Name",
            columnName: "middleName",
            sortable: true,
        },
        {
            label: "Last Name",
            columnName: "lastName",
            sortable: true,
        },
        {
            label: "Driver Status",
            columnName: "driverStatus",
            valueInterpreter: DriverStatusFormatter,
            conditionalFormatting: (value)=>{
                if(value !== "inactive")return null;
                return `& > * {color:var(--alert-color);
                        font-weight:700;`

            },
            sortable: true,
        },
        {
            label: "Driver Type",
            columnName: "driverType",
            sortable: true,
        },
        {
            label: "Phone Number",
            columnName: "phoneNumber",
        },
        {
            label: "CDL Number",
            columnName: "licenseNumber",
        },
        {
            label: "Current Truck",
            columnName:"currentTruckNumber",
            alignment: "right",
            valueGenerator: (data)=>{
                return NestedValueExtractor(data, "currentTruckNumber");
            },
        }
    ]
}
